import { FgStockStatusEnum } from './fg-stock-status.enum';
export class BulkStockOutRequest {
    stockId:number;
    status:FgStockStatusEnum;
    updatedUser: string;
    stockOutQty: number;
    stockOutType?:string
    totalStockOutQty?:number
    totalIssuedQty?:number
    issuedQty?:number
    stockOutLoosePouches?:number
    poNumber?:string
    allocatedSoId?:number
    allocatedSoItemId?:number
    selectedVariantId?:number
    stockOutDate?:any
    availableLoosePouches?: number
    availableCartons?:number
    pouches?:number

    constructor(stockId:number,status:FgStockStatusEnum,updatedUser: string,stockOutQty:number,stockOutType?:string,totalStockOutQty?:number,totalIssuedQty?:number,issuedQty?:number,stockOutLoosePouches?:number,poNumber?:string,allocatedSoId?:number,allocatedSoItemId?:number,selectedVariantId?:number,stockOutDate?:any,availableLoosePouches?: number,availableCartons?:number,pouches?:number){
        this.stockId = stockId;
        this.status = status;
        this.updatedUser = updatedUser;
        this.stockOutQty = stockOutQty;
        this.stockOutType = stockOutType;
        this.totalStockOutQty = totalStockOutQty;
        this.totalIssuedQty = totalIssuedQty;
        this.issuedQty = issuedQty;
        this.stockOutLoosePouches = stockOutLoosePouches
        this.poNumber = poNumber
        this.allocatedSoId = allocatedSoId
        this.allocatedSoItemId = allocatedSoItemId
        this.selectedVariantId = selectedVariantId
        this.stockOutDate = stockOutDate
        this.availableLoosePouches = availableLoosePouches
        this.availableCartons = availableCartons
        this.pouches = pouches
    }
}
